import { makeStyles } from "@material-ui/core";
import { Checkbox, TextField } from "@mui/material";
import moment from "moment";
import React from "react";
import { Col, Row } from "reactstrap";
import "./printCss.css";
import guamLogo from "../../../../../assets/GuamSeal.svg";
import guamLogo2 from "../../../../../assets/GuamLogo.png";
import AmendmentPrint from "./AmendmentPrint";
import CancelCloseAnnouncePrint from "./CancelCloseAnnouncePrint";
import { isJsonArrayString } from "../../../../../_helper/helper";
import DOASIGNATURE from "../../../../../assets/images/other-images/DOA_Signature.png";

const useStyles = makeStyles({
  newsmallTextField: {
    width: "100%", // Custom width
    "& .MuiInputBase-input": {
      fontSize: "13px",
      // padding: "5px 10px", // Custom padding
    },
  },
});

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { data, status, selectivefactor, title = '', title2 = '' } = props;

  //  let requirement = typeof data.requirements == 'object' ?data.requirements ?  data.requirements : {}:data.requirements && data.requirements !== null ? isJsonArrayString(data.requirements) : {}
  let requirement = data.requirements ? data.requirements : {}
  const classes = useStyles();
  return (
    <div ref={ref}>
      <style type="text/css" media="print">
        {`
          @page {
            margin: 0;
          }

          

          header {
            display: none;
          }
        `}
      </style>
      {/* <div
        style={{
          width: "100%",
           
        }}
      > */}
      {status == "Amendment" ?
        <div>
          <AmendmentPrint data={data} />
        </div> : null}
      {status == "Cancel" || status == "Close" ?
        <div style={{ pageBreakBefore: "always" }}>
          <CancelCloseAnnouncePrint status={status} data={data} />
        </div>
        : null}

      <div style={{ padding: "10px", pageBreakBefore: "always" }}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "30%", textAlign: "left" }}>
            <span
              style={{
                float: "left",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo2} alt="Logo 1" style={{ height: "60px" }} />
              <p className="tophead">EDWARD M. BIRN</p>
              <p className="tophead">Director (Direktot)</p>
              <p className="tophead">RENA BORJA</p>
              <p className="tophead">Deputy Director (Sigundo Direktot)</p>
            </span>
          </div>
          <div style={{ width: "40%", textAlign: "center" }}>
            <div style={{ display: "inline-block", color: "green    " }}>
              <h1
                className="admin1"
                style={{ fontSize: "24px", fontWeight: "700" }}
              >
                DEPARTMENT OF ADMINISTRATION
              </h1>
              <h3 className="admin1" style={{ fontSize: "16px" }}>
                DIPATTAMENTON AMETNESTRASYON
              </h3>
              <h4
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "700" }}
              >
                HUMAN RESOURCES DIVISION
              </h4>
              <h3
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "600" }}
              >
                (Dibision Inadilanto yan Guinaha Para Taotao)
              </h3>
              <h6
                className="tophead"
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                Telephone (Telifon): (671) 475-1288/1103 . Fax (Faks): (671)
                477-3671
              </h6>
            </div>
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>
            <span
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo} alt="Logo 2" style={{ height: "60px" }} />
              <p className="tophead">LOURDES A. LEON GUERRERO</p>
              <p className="tophead">Governor (Maga’håga)</p>
              <p className="tophead">JOSHUA F. TENORIO</p>
              <p className="tophead">Lt. Governor (Sigundo Maga’låhi)</p>
            </span>
          </div>
        </div>
        <div className="examination">
          <h2 className="examination1" style={{ fontSize: "24px", textAlign: "center" }}>
            {title}
            {/* {data?.secondaryAnnouncementType=="DEPARTMENTAL" ? "DEPARTMENTAL COMPETITIVE EXAMINATION":
            "OPEN COMPETITIVE EXAMINATION"} */}
          </h2>
          <div className="examination2">
            <div className="maincontent">
              <div className="examination2-content">
                <div className="cont-1">
                  To establish a list for the position of
                </div>
                <h1
                  className="cont-2"
                  style={{ fontSize: "24px", fontWeight: "600", textAlign: "center" }}
                >
                  {data?.positionTitle} {data?.secondarykpp ? ` (${data?.secondarykpp})` : null}
                </h1>
                <div className="cont-3">
                  <h4 style={{ fontSize: "16px" }}>Announcement Number :</h4>
                  <div>{data?.announcementId}</div>
                </div>

                <div className="cont-3">
                  {/* <h4 style={{ fontSize: "16px" }}>Remarks : </h4>   */}
                  <h4 style={{ fontSize: "16px", fontWeight: 600, textAlign: 'center' }}> <span style={{ fontWeight: 'normal' }}>Remarks : </span>  {data?.remarks ?? "-"}</h4>
                </div>

                <div className="cont-4">
                  <div className="open1">
                    <h4 style={{ fontSize: "16px" }}>Open : &nbsp;</h4>
                    <div>{data?.dateEntered ? moment(data?.datePosted).format("MM-DD-YYYY") : null}</div>&nbsp;
                  </div>
                  <div className="open2">
                    {data?.status?.trim() == "CONTINUOUS" ?
                      <h4 style={{ fontSize: "16px" }}>CONTINUOUS&nbsp;</h4>
                      : <>
                        <h4 style={{ fontSize: "16px" }}>Close :&nbsp;</h4>
                        <div>{data?.dateEntered ? moment(data?.dateClosed).format("MM-DD-YYYY") : null}</div>
                      </>
                    }
                  </div>
                </div>
                <div className="cont-5">
                  <h4 style={{ fontSize: "16px" }}>{data?.payPlan ?? "-"}</h4>
                  <span>OPEN: {data?.payGrade || data?.grade}-{data?.fromStep || data?.step}; ${data?.fromSalary || data?.salary} P/A -- {data?.payGrade || data?.grade}-{data?.toStep}; ${data?.toSalary} P/A</span>
                  {data?.secondaryPayGrade != "" && data?.secondaryFromStep != "" && data?.secondaryToStep != "" ?
                    <div><span>PROMOTION: {data?.secondaryPayGrade}-{data?.secondaryFromStep}; ${data?.secondaryFromSalary} P/A -- {data?.secondaryPayGrade}-{data?.secondaryToStep}; ${data?.secondaryToSalary} P/A</span></div>
                    : null}
                </div>
                <div className="cont-6">
                  <p>
                    The Government of Guam may offer competitive benefit
                    packages, which includes retirement (Defined Contribution
                    Plan 401 and 457), health insurance plans, cafeteria plan,
                    an Employee Assistance Program, annual and sick leave, paid
                    holidays and life insurance. For additional information
                    regarding the Government of Guam Retirement, please visit
                    <a href="https://www.ggrf.com/" target="_blank" rel="noreferrer">www.ggrf.com</a>. For other inquires please visit Department of Administration website <a href='https://hr.doa.guam.gov/' target="_blank" rel="noreferrer">www.hr.doa.guam.gov</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contentlist">
          {requirement?.WhoCanApply ?
            <div className="apply">
              <h4>Who Can Apply</h4>
              <p>{requirement?.WhoCanApply}</p>
            </div> : null}
          {requirement?.SelectiveFactor ?
            <div className="apply">
              <h4>Remarks</h4>
              <p>{requirement?.SelectiveFactor}</p>
            </div> : null}
          {requirement?.QualificationRequirement ?
            <div className="apply">
              <h4>Qualification Requirements</h4>
              <p>
                {requirement?.QualificationRequirement}
              </p>

            </div> : null}
          {requirement?.NecessarySpecialQualifications ?
            <div className="apply">
              <h4>Necessary Special Qualification</h4>
              <p>
                {requirement?.NecessarySpecialQualifications}
              </p>

            </div> : null}
          {requirement?.NatureofWork ?
            <div className="apply">
              <h4>Nature of work</h4>
              <p>
                {requirement?.NatureofWork}
              </p>
            </div> : null}
          {requirement?.illustrativeExofWork ?
            <div className="apply">
              <h4>Illustrative Examples of Work</h4>
              <p>
                {requirement?.illustrativeExofWork}
              </p>
            </div> : null}
          {requirement?.KnowledgeAbilitiesSkills ?
            <div className="apply">
              <h4>Knowledge, Abilities & Skills</h4>
              <p style={{ border: "none" }}>
                {requirement?.KnowledgeAbilitiesSkills}
              </p>
            </div> : null}
          {requirement?.MinimumEducationReq ?
            <div className="apply">
              <h4>Minimum Educational Requirements</h4>
              <p>
                {requirement?.MinimumEducationReq}
              </p>
            </div> : null}
          {requirement?.DocRequirement ?
            <div className="apply">
              <h4>Documentation Requirements</h4>
              <p>
                {requirement?.DocRequirement}
              </p>
            </div> : null}

        </div>
        {requirement?.ProhibitionPursuant || requirement?.SuitabilityDeterminationForm || requirement?.ExaminationReq || requirement?.InterviewProcedures || requirement?.EmploymentMedicalExamination || requirement?.WorkEligibility || requirement?.DrugScreening || requirement?.PoliceCourtClearances || requirement?.WhereToApply || requirement?.ForMoreInfo ?
          <>
            <div style={{ pageBreakBefore: "always", marginTop: "20px" }}></div>
            <div className="treasury" >
              <h4 style={{ fontSize: "24px", textAlign: "center" }}> {data?.positionTitle} {data?.secondarykpp ? ` (${data?.secondarykpp})` : null}</h4>
              <h5>
                {title2 ? title2 : title}
                {/* {data?.secondaryAnnouncementType=="DEPARTMENTAL" ? "DEPARTMENTAL COMPETITIVE EXAMINATION":
            "OPEN COMPETITIVE EXAMINATION"} */}
              </h5>
            </div>
            {requirement?.SuitabilityDeterminationForm ?
              <div className="apply">
                <h4>Suitability Determination Form</h4>
                <p>
                  {requirement?.SuitabilityDeterminationForm}
                </p>
              </div> : null}
            {requirement?.ProhibitionPursuant ?
              <div className="apply">
                <h4>Prohibition Pursuant to P.L. 28-98</h4>
                <p>
                  {requirement?.ProhibitionPursuant}
                </p>
              </div> : null}
            {requirement?.InterviewProcedures ?
              <div className="apply">
                <h4>Interviewing Procedures</h4>
                <p>
                  {requirement?.InterviewProcedures}
                </p>
              </div> : null}
            <div className="contentlist">
              {requirement?.ExaminationReq ?
                <div className="apply">
                  <h4>Examination Requirements</h4>
                  <p>
                    {requirement?.ExaminationReq}
                  </p>
                </div> : null}
              {requirement?.EmploymentMedicalExamination ?
                <div className="apply">
                  <h4>Employment Medical Examination</h4>
                  <p>
                    {requirement?.EmploymentMedicalExamination}
                  </p>
                </div> : null}
              {requirement?.WorkEligibility ?
                <div className="apply">
                  <h4>Work Eligibility</h4>
                  <p>
                    {requirement?.WorkEligibility}
                  </p>
                </div> : null}
              {requirement?.DrugScreening ?
                <div className="apply">
                  <h4>Drug Screening</h4>
                  <p>
                    {requirement?.DrugScreening}
                  </p>
                </div> : null}
              {requirement?.PoliceCourtClearances ?
                <div className="apply">
                  <h4>Police & Court Clearances Requirements I</h4>
                  <p>
                    {requirement?.PoliceCourtClearances}
                  </p>
                </div> : null}
              {requirement?.WhereToApply ?
                <div className="apply">
                  <h4>Where to Apply</h4>
                  <p>
                    {requirement?.WhereToApply}
                  </p>
                </div> : null}
              {requirement?.ForMoreInfo ?
                <div className="apply">
                  <h4>For More Information</h4>
                  <p>
                    {requirement?.ForMoreInfo}
                  </p>
                </div> : null}
            </div></> : null}
        {/* <div className="sig">
          <h4> SHANE G.L. NGATA</h4>
          <span>PERSONNEL SERVICES ADMINISTRATOR</span>
          <p>HUMAN RESOURCES DIVISION</p>
        </div> */}
        <Row style={{ marginTop: "100px" }}>
          <Col sm={4}></Col>
          <Col sm={4}></Col>
          <Col sm={4}>
            <img src={DOASIGNATURE} alt="DOA Signature" style={{ width: "60%", height: "auto", display: "block", margin: "0 auto" }} />
            <div style={{ borderBottom: "1px solid black" }}>

            </div>
            {/* <div style={{ fontSize: "14px", textAlign: "center" }}>Appointing Authority</div> */}
            <div style={{ fontSize: "14px", textAlign: "center" }}>Director of Administration</div>
          </Col>
        </Row>

        <Row style={{ marginTop: "40px" }}>
          <Col sm={12}>
            {/* <b> */}
            WE ARE AN EQUAL EMPLOYMENT OPPORTUNITY EMPLOYER. WE DO NOT DISCRIMINATE ON THE BASIS OF RACE, RELIGION, COLOR, SEX, AGE, DISABILITY, EXCEPT FOR POSITIONS REQUIRING BONA FIDE OCCUPATIONAL QUALIFICATION.
            {/* </b> */}
          </Col>
        </Row>


      </div>
    </div>
  );
});

export default ComponentToPrint;
